import { render } from "./KRPanel.vue?vue&type=template&id=6016c4ac&scoped=true"
import script from "./KRPanel.vue?vue&type=script&lang=js"
export * from "./KRPanel.vue?vue&type=script&lang=js"

import "./KRPanel.vue?vue&type=style&index=0&id=6016c4ac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6016c4ac"

export default script